/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_PAYOUT_CONTENT: {
    offset: 0,
    size: 10,
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.payoutPage.getPayout',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_PAYOUT_CONTENT' },
      },
    },
    GET_PAYOUT_CONTENT: {
      invoke: {
        id: 'getPayout',
        src: 'getPayout',
        onDone: {
          target: 'RENDER_PAYOUT',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_PAYOUT_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_PAYOUT: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_PAYOUT_CONTENT',
        },
      },
    },
    RENDER_PAYOUT_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
